import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getCookie } from '../../utils/cookie';

const objectToCSV = (obj, valueSeparator = '=', itemsSeparator = ',') =>
    Object.keys(obj).map(key => `${key}${valueSeparator}${obj[key]}`).join(itemsSeparator);

const flow = (...actions) => value => actions.reduce((args, action) => action(args), value);

const getWindowPosition = (options, opener) => ({
    top: ((opener.innerHeight - options.height) / 2) + opener.screenY,
    left: ((opener.innerWidth - options.width) / 2) + opener.screenX,
});

class LoginWindow extends Component {
    static defaultProps = {
        width: 920,
        height: 575,
        windowName: '',
        cookieName: '',
        authUrl: '',
    }

    static propTypes = {
        width: PropTypes.number,
        height: PropTypes.number,
        windowName: PropTypes.string,
        cookieName: PropTypes.string,
        authUrl: PropTypes.string,
        onLoginSuccess: PropTypes.func.isRequired,
        onBackClick: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);
        this.state = {
            loginHandled: false,
        };
    }

    componentWillMount() {
        const {
            width,
            height,
            authUrl,
            windowName,
        } = this.props;
        const position = getWindowPosition({ width, height }, window);
        const configurationString = objectToCSV({
            ...position,
            width,
            height,
        });
        const newWindowInstance = window.open(authUrl, windowName, configurationString);
        if (newWindowInstance) {
            newWindowInstance.focus();
        }
        window.addEventListener('message', this.onMessage, false);
        const onTimerCheck = flow(
            this.checkBookmakerCookie,
            this.checkIfWindowOpened,
        );
        const timerIdentifier = setInterval(onTimerCheck, 100);
        this.setState({
            newWindowInstance,
            timerIdentifier,
        });
    }

    componentWillReceiveProps({
        width: newWidth,
        height: newHeight,
        authUrl: newAuthUrl,
    }) {
        const { newWindowInstance } = this.state;
        if (newWindowInstance && !newWindowInstance.closed) {
            const {
                width,
                height,
                authUrl,
            } = this.props;
            if (authUrl !== newAuthUrl) {
                newWindowInstance.location.href = newAuthUrl;
            }
            if (width !== newWidth || height !== newHeight) {
                newWindowInstance.resizeTo(newWidth, newHeight);
                newWindowInstance.focus();
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.onMessage, false);
        clearTimeout(this.state.timerIdentifier);
        const { newWindowInstance } = this.state;
        if (newWindowInstance && !newWindowInstance.closed) {
            newWindowInstance.close();
        }
    }

    onMessage = ({ data: { event, data } }) => {
        if (this.state.loginHandled) {
            return;
        }
        if (event === 'login') {
            if (data.success) {
                this.props.onLoginSuccess();
            } else {
                this.props.onBackClick();
            }
        }
        if ((event === 'default') && data.success) {
            this.props.onBackClick();
        }
        if (event === 'default' || event === 'login') {
            this.setState({ loginHandled: true });
            clearTimeout(this.state.timerIdentifier);
        }
    }

    checkBookmakerCookie = () => {
        const {
            cookieName,
        } = this.props;
        if (getCookie(cookieName)) {
            this.onMessage({
                data: {
                    event: 'login',
                    data: { success: true },
                },
            });
        }
    }

    checkIfWindowOpened = () => {
        const {
            newWindowInstance,
        } = this.state;
        if (newWindowInstance && newWindowInstance.closed) {
            this.onMessage({
                data: {
                    event: 'login',
                    data: { success: false },
                },
            });
        }
    }

    render() {
        const {
            newWindowInstance,
        } = this.state;
        const windowNotOpened = !newWindowInstance ||
            typeof newWindowInstance.closed === 'undefined';
        return windowNotOpened
            ? (<span>Please enable pop-ups in your web browser to log in</span>)
            : null;
    }
}

export default LoginWindow;



// WEBPACK FOOTER //
// /src/js/common/loginPage/components/LoginWindow.jsx